<script lang="ts">
	import { attrValue } from '$lib/utils/html';
	import type { ButtonBoxType } from '../types';
	import ButtonLabeled from './ButtonLabeled.svelte';

	export let props: ButtonBoxType = {};

	$: props.size = props.size || 'default';

	$: props = {
		...props,
		classNames: attrValue([
			props.classNames,
			(props.iconLeft || props.iconRight) && !props.label
				? 'p-2'
				: props.iconLeft || props.iconRight
					? 'px-3 py-[12px]'
					: 'px-3 py-3',
			props.roundedFull ? 'rounded-full' : 'rounded-lg',
			'font-semibold flex-shrink-0'
		])
	};
</script>

<ButtonLabeled {...$$restProps} {props} on:click>
	<slot />
</ButtonLabeled>
